<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout } from '@Shared';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import ShowcaseImage from '@Components/ShowcaseImage.vue';

const router = useRouter();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();

const returnToPreviousPage = () => {
    // Go back to the previous page
    router.back();
};
</script>

<template>
    <showcase-layout
        title="Uh oh, there was an issue"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        class="text-center"
        show-powered-by>

        <template #mobileAccent>
            <div class="esignature-error-candy">
                <img
                    class="esignature-error-candy__image"
                    :src="'/images/esignature/error.svg'"
                />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <app-form-content-layout>
            <div class="error-content text-center">
                <p>
                    We are experiencing technical difficulties! You can contact our support team by clicking the chatbot on the bottom-left of this page.
                    <br />
                    <br />
                    Or <a href="#" @click.prevent="returnToPreviousPage">try again</a> in a few minutes. 
                </p>
            </div>
        </app-form-content-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.esignature-error-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }
}

.error-content {
    line-height: 1.5;
}

.text-center {
    text-align: center;
}

:deep(.showcase-layout__mobile-accent) {
    @include tablet-and-down {
        margin-top: 4.38rem !important;
    }
}
</style>